import {
  Type, AlignLeft, ListChecks, Calendar, Hash, Camera, PenLine, Clock, Info,
  CheckCircle2, ToggleLeft, CheckSquare, List, User, Users,
} from "lucide-react";

export const FIELD_TYPES = [
  { value: "pass_fail_na", label: "Pass / Fail / N/A", icon: CheckCircle2, group: "Choices" },
  { value: "yes_no_na", label: "Yes / No / N/A", icon: ToggleLeft, group: "Choices" },
  { value: "checkbox", label: "Checkbox", icon: CheckSquare, group: "Choices" },
  { value: "dropdown_one", label: "Dropdown — select one", icon: List, group: "Choices" },
  { value: "dropdown_multi", label: "Dropdown — select multiple", icon: ListChecks, group: "Choices" },
  { value: "short_text", label: "Short answer", icon: Type, group: "Text" },
  { value: "long_text", label: "Long answer", icon: AlignLeft, group: "Text" },
  { value: "info", label: "Text info block", icon: Info, group: "Text" },
  { value: "number", label: "Number", icon: Hash, group: "Data" },
  { value: "date", label: "Date", icon: Calendar, group: "Data" },
  { value: "time", label: "Time", icon: Clock, group: "Data" },
  { value: "select_worker", label: "Select worker", icon: User, group: "People" },
  { value: "select_workers", label: "Select multiple workers", icon: Users, group: "People" },
  { value: "photo", label: "Photo upload", icon: Camera, group: "Capture" },
  { value: "signature", label: "Signature", icon: PenLine, group: "Capture" },
];

// Types kept only so templates built before the SiteDocs-style rebuild still render.
export const LEGACY_TYPES = [
  { value: "yes_no", label: "Yes / No (legacy)", icon: ToggleLeft },
  { value: "multiple_choice", label: "Multiple choice (legacy)", icon: ListChecks },
];

export const fieldTypeMeta = (value) =>
  FIELD_TYPES.find((t) => t.value === value) ||
  LEGACY_TYPES.find((t) => t.value === value) ||
  FIELD_TYPES.find((t) => t.value === "short_text");

export const isDropdownType = (value) => value === "dropdown_one" || value === "dropdown_multi";

export const TEMPLATE_TYPES = ["FLAH", "Vehicle Inspection", "Incident Report", "Inspection",
  "Corrective Action", "Equipment/Tool Request", "Maintenance Request"];

export const newId = () => crypto.randomUUID().slice(0, 8);

export const newField = (type = "short_text") => {
  const field = { id: newId(), type, label: "", required: false };
  if (isDropdownType(type)) field.list_id = null;
  return field;
};

export const newSection = () => ({ id: newId(), title: "", collapsible: false, repeatable: false, fields: [] });

export const emptySchema = () => ({ sections: [newSection()] });

export const countFields = (schema) =>
  (schema?.sections || []).reduce((n, s) => n + (s.fields || []).length, 0);

// Which custom lists a template's schema references (for usage counts).
export const listIdsInSchema = (schema) => {
  const ids = new Set();
  (schema?.sections || []).forEach((s) =>
    (s.fields || []).forEach((fl) => { if (fl.list_id) ids.add(fl.list_id); })
  );
  return ids;
};
